const state = {
  filters: [],
}

const getters = {
  customIcons: () => {
    return [
      'soilTemp',
      'soilEC',
      'epsilon',
    ]
  },
  filters: (state) => state.filters,
  filtersByType: (state, getters) => {
    return {
      lightFilters: getters.lightFilters,
      moistureFilters: getters.moistureFilters,
      co2Filters: getters.co2Filters,
      tempFilters: getters.tempFilters,
      humidityFilters: getters.humidityFilters,
      soilTempFilters: getters.soilTempFilters,
    }
  },
  lightFilters: (state) => {
    return state.filters.filter(statusFilter => {
      return statusFilter.key === 'lightSensors'
    })
  },
  moistureFilters: (state) => {
    return state.filters.filter(statusFilter => {
      return statusFilter.key === 'moistureSensors'
    })
  },
  co2Filters: (state) => {
    return state.filters.filter(statusFilter => {
      return statusFilter.key === 'co2Sensors'
    })
  },
  tempFilters: (state) => {
    return state.filters.filter(statusFilter => {
      return statusFilter.key === 'tempSensors'
    })
  },
  humidityFilters: (state) => {
    return state.filters.filter(statusFilter => {
      return statusFilter.key === 'humiditySensors'
    })
  },
  soilTempFilters: (state) => {
    return state.filters.filter(statusFilter => {
      return statusFilter.key === 'soilTempSensors'
    })
  }
}

const actions = {
  addFilter({commit}, filter) {
    commit('addFilter', filter)
  },
  removeFilter({commit}, filter) {
    commit('removeFilter', filter)
  }
}

const mutations = {
  addFilter(state, statusFilter) {
    const existingFilter = state.filters.find(eachFilter => eachFilter.key === statusFilter.key)
    if (!existingFilter) {
      state.filters.push(statusFilter)
    }
  },
  removeFilter(state, statusFilterKey) {
    state.filters = state.filters.filter(eachFilter => eachFilter.key !== statusFilterKey)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
